 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "_assets/js/" + ({"About":"About","ActiveQuestions~AppLayout~Campaign~CampaignRecords~CheckIn~DigitalCard~Error~Home~Notification~Notif~e0bf17e8":"ActiveQuestions~AppLayout~Campaign~CampaignRecords~CheckIn~DigitalCard~Error~Home~Notification~Notif~e0bf17e8","ActiveQuestions":"ActiveQuestions","AppLayout":"AppLayout","Campaign":"Campaign","CampaignRecords":"CampaignRecords","CheckIn~Home~Profile~ProfileEdit~Scanner~StampCard":"CheckIn~Home~Profile~ProfileEdit~Scanner~StampCard","CheckIn~Home~Profile~Scanner~StampCard":"CheckIn~Home~Profile~Scanner~StampCard","CheckIn":"CheckIn","Home":"Home","QA~QADetail~Scanner":"QA~QADetail~Scanner","Scanner":"Scanner","StampCard":"StampCard","ProfileEdit":"ProfileEdit","DigitalCard~LimitedTimeMissionDetail~Merchant~ParkingCoupon":"DigitalCard~LimitedTimeMissionDetail~Merchant~ParkingCoupon","AppointStoreMap~DigitalCard~ParkingCoupon~Send":"AppointStoreMap~DigitalCard~ParkingCoupon~Send","DigitalCard":"DigitalCard","ParkingCoupon":"ParkingCoupon","Error":"Error","Notification":"Notification","NotificationBar":"NotificationBar","QA~QADetail":"QA~QADetail","QA":"QA","QADetail":"QADetail","ScanError":"ScanError","Service":"Service","Survey":"Survey","Turntable":"Turntable","AppointStore":"AppointStore","AppointStoreMap":"AppointStoreMap","Send":"Send","Article":"Article","Articles":"Articles","Merchant~Profile":"Merchant~Profile","Profile":"Profile","Consumption":"Consumption","CustomerService":"CustomerService","DDwalletAgreement":"DDwalletAgreement","LimitedTimeMissionDetail":"LimitedTimeMissionDetail","Merchant":"Merchant","Footer":"Footer","HealthyStep":"HealthyStep","MyStampCards":"MyStampCards","PaymentRecord":"PaymentRecord","Record":"Record","Setting":"Setting","SettingDeleteAccount":"SettingDeleteAccount","StoreInfo":"StoreInfo","StoreStamps":"StoreStamps","Stores":"Stores","Video":"Video","Websites":"Websites"}[chunkId]||chunkId) + "." + {"About":"2bdd52a5","ActiveQuestions~AppLayout~Campaign~CampaignRecords~CheckIn~DigitalCard~Error~Home~Notification~Notif~e0bf17e8":"1d490901","ActiveQuestions":"c60ccd49","AppLayout":"deb9f6ea","Campaign":"7989b730","CampaignRecords":"dce81cb9","CheckIn~Home~Profile~ProfileEdit~Scanner~StampCard":"8711a2ff","CheckIn~Home~Profile~Scanner~StampCard":"0e972c53","CheckIn":"ef6f5b58","Home":"1b36038a","QA~QADetail~Scanner":"2bffc151","Scanner":"b3a76a9a","StampCard":"c4c239da","ProfileEdit":"f5f73a90","DigitalCard~LimitedTimeMissionDetail~Merchant~ParkingCoupon":"b55ecd3c","AppointStoreMap~DigitalCard~ParkingCoupon~Send":"21335813","DigitalCard":"65aa2e45","ParkingCoupon":"3830b3fb","Error":"51aed788","Notification":"1399ab48","NotificationBar":"d8adb9e6","QA~QADetail":"ed12808b","QA":"95aea00e","QADetail":"d56b5462","ScanError":"9d8695ca","Service":"af2785ba","Survey":"6887da85","Turntable":"b1cfacb5","AppointStore":"ea510a97","AppointStoreMap":"0fe4fed2","Send":"faf7641f","Article":"291946bd","Articles":"1e45ca7e","Merchant~Profile":"65898fe0","Profile":"8ff5a5f1","Consumption":"a81cbd6d","CustomerService":"8648346b","DDwalletAgreement":"073b7767","LimitedTimeMissionDetail":"a7ff19c0","Merchant":"fc749171","Footer":"2a3d2c6b","HealthyStep":"56ca13e6","MyStampCards":"a34e0f6d","PaymentRecord":"632e1951","Record":"ec8683f2","Setting":"3822e24c","SettingDeleteAccount":"6aeff4e6","StoreInfo":"44e0d7ee","StoreStamps":"5af49acd","Stores":"472b01e5","Video":"83513ccd","Websites":"0d5b1829","chunk-3ed9be33":"93a9bac8","chunk-6bab0a12":"172010f7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ActiveQuestions~AppLayout~Campaign~CampaignRecords~CheckIn~DigitalCard~Error~Home~Notification~Notif~e0bf17e8":1,"ActiveQuestions":1,"Campaign":1,"CheckIn~Home~Profile~Scanner~StampCard":1,"Home":1,"QA~QADetail~Scanner":1,"Scanner":1,"ProfileEdit":1,"DigitalCard~LimitedTimeMissionDetail~Merchant~ParkingCoupon":1,"DigitalCard":1,"ParkingCoupon":1,"Notification":1,"QA~QADetail":1,"QA":1,"QADetail":1,"Service":1,"Turntable":1,"AppointStore":1,"AppointStoreMap":1,"Send":1,"Profile":1,"Consumption":1,"CustomerService":1,"DDwalletAgreement":1,"LimitedTimeMissionDetail":1,"Merchant":1,"HealthyStep":1,"Setting":1,"SettingDeleteAccount":1,"StoreInfo":1,"chunk-3ed9be33":1,"chunk-6bab0a12":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "_assets/css/" + ({"About":"About","ActiveQuestions~AppLayout~Campaign~CampaignRecords~CheckIn~DigitalCard~Error~Home~Notification~Notif~e0bf17e8":"ActiveQuestions~AppLayout~Campaign~CampaignRecords~CheckIn~DigitalCard~Error~Home~Notification~Notif~e0bf17e8","ActiveQuestions":"ActiveQuestions","AppLayout":"AppLayout","Campaign":"Campaign","CampaignRecords":"CampaignRecords","CheckIn~Home~Profile~ProfileEdit~Scanner~StampCard":"CheckIn~Home~Profile~ProfileEdit~Scanner~StampCard","CheckIn~Home~Profile~Scanner~StampCard":"CheckIn~Home~Profile~Scanner~StampCard","CheckIn":"CheckIn","Home":"Home","QA~QADetail~Scanner":"QA~QADetail~Scanner","Scanner":"Scanner","StampCard":"StampCard","ProfileEdit":"ProfileEdit","DigitalCard~LimitedTimeMissionDetail~Merchant~ParkingCoupon":"DigitalCard~LimitedTimeMissionDetail~Merchant~ParkingCoupon","AppointStoreMap~DigitalCard~ParkingCoupon~Send":"AppointStoreMap~DigitalCard~ParkingCoupon~Send","DigitalCard":"DigitalCard","ParkingCoupon":"ParkingCoupon","Error":"Error","Notification":"Notification","NotificationBar":"NotificationBar","QA~QADetail":"QA~QADetail","QA":"QA","QADetail":"QADetail","ScanError":"ScanError","Service":"Service","Survey":"Survey","Turntable":"Turntable","AppointStore":"AppointStore","AppointStoreMap":"AppointStoreMap","Send":"Send","Article":"Article","Articles":"Articles","Merchant~Profile":"Merchant~Profile","Profile":"Profile","Consumption":"Consumption","CustomerService":"CustomerService","DDwalletAgreement":"DDwalletAgreement","LimitedTimeMissionDetail":"LimitedTimeMissionDetail","Merchant":"Merchant","Footer":"Footer","HealthyStep":"HealthyStep","MyStampCards":"MyStampCards","PaymentRecord":"PaymentRecord","Record":"Record","Setting":"Setting","SettingDeleteAccount":"SettingDeleteAccount","StoreInfo":"StoreInfo","StoreStamps":"StoreStamps","Stores":"Stores","Video":"Video","Websites":"Websites"}[chunkId]||chunkId) + "." + {"About":"31d6cfe0","ActiveQuestions~AppLayout~Campaign~CampaignRecords~CheckIn~DigitalCard~Error~Home~Notification~Notif~e0bf17e8":"60ab7b3e","ActiveQuestions":"07018f02","AppLayout":"31d6cfe0","Campaign":"8b29a8bd","CampaignRecords":"31d6cfe0","CheckIn~Home~Profile~ProfileEdit~Scanner~StampCard":"31d6cfe0","CheckIn~Home~Profile~Scanner~StampCard":"45095726","CheckIn":"31d6cfe0","Home":"c58c2d2d","QA~QADetail~Scanner":"6881d026","Scanner":"79b993d2","StampCard":"31d6cfe0","ProfileEdit":"b12d205c","DigitalCard~LimitedTimeMissionDetail~Merchant~ParkingCoupon":"7976405a","AppointStoreMap~DigitalCard~ParkingCoupon~Send":"31d6cfe0","DigitalCard":"e053213f","ParkingCoupon":"edc6b3f7","Error":"31d6cfe0","Notification":"e97cea73","NotificationBar":"31d6cfe0","QA~QADetail":"35254725","QA":"2723723b","QADetail":"f7f173ba","ScanError":"31d6cfe0","Service":"90312736","Survey":"31d6cfe0","Turntable":"08d4355b","AppointStore":"575cea8c","AppointStoreMap":"9e5ec5f6","Send":"d32b8081","Article":"31d6cfe0","Articles":"31d6cfe0","Merchant~Profile":"31d6cfe0","Profile":"4f237e92","Consumption":"7be8b331","CustomerService":"d8ea277f","DDwalletAgreement":"3ddda78e","LimitedTimeMissionDetail":"921dffe7","Merchant":"ab1a6c5e","Footer":"31d6cfe0","HealthyStep":"88ddbd68","MyStampCards":"31d6cfe0","PaymentRecord":"31d6cfe0","Record":"31d6cfe0","Setting":"799928d3","SettingDeleteAccount":"5e211bad","StoreInfo":"48f1567a","StoreStamps":"31d6cfe0","Stores":"31d6cfe0","Video":"31d6cfe0","Websites":"31d6cfe0","chunk-3ed9be33":"e48d0d05","chunk-6bab0a12":"ddb9621e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
